import router from '../../shared/router';
import MenuService from '../../core/components/sidebar/MenuService';
import MenuItem from '../../core/components/sidebar/MenuItem';
import MonitoringView from './MonitoringView';
import FileLogsView from './FileLogs/FileLogsView';
import JobQueue from './JobQueue/JobQueue';

// Register monitoring routes directly to avoid duplicates
router.addRoute('app', {
  path: '/monitoring', 
  component: MonitoringView,
  children: [
    {path: 'file-logs', component: FileLogsView},
    {path: 'job-queue', name: 'JobQueue', component: JobQueue}, // Add new Job Queue component to Monitoring module
  ],
});

// MenuService.addItem(new MenuItem('Monitoring', {
//   text: 'Monitoring',
//   weight: 100,
//   uuid: 'Monitoring',
//   permission: 'read',
//   icon: ['fas', 'chart-bar'],
//   children: [
//     {
//       path: '/monitoring/file-logs',
//       text: 'File Logs',
//       weight: 1,
//       icon: ['fas', 'clipboard-list']
//     }
//   ]
// }));
